import { disableArrowKeys } from "components/dashboard/data-input-output-table/utils";
import { SelectionValuesType } from "components/dashboard/product-template-table/utils/interfaces";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import React from "react";
import { CellSubType } from "utils/enums";

const invalidLongKeys = ["e", "E", "+", "-", "."];

const EditableCell = ({
  value,
  subType,
  onCommit,
  hideInputStyles,
  selectionValues,
}: {
  value: string;
  subType: CellSubType;
  onCommit: (v: string) => void;
  hideInputStyles?: boolean;
  selectionValues?: SelectionValuesType;
}) => {
  const handleKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      (e.target as HTMLInputElement).blur();
    }
    disableArrowKeys(e);
    if (subType === CellSubType.LONG && invalidLongKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement> | DropdownChangeEvent) => {
    const v = e.target.value;
    if (subType === CellSubType.LONG && !/^-?\d*$/.test(v)) return;
    onCommit(v);
  };

  const dropdownOptions = selectionValues?.map(v => ({ label: v, value: v }));

  return selectionValues?.length ? (
    <Dropdown
      style={{ width: "100%", textAlign: "left" }}
      value={value}
      options={dropdownOptions}
      optionLabel="label"
      optionValue="value"
      onChange={handleChange}
      onClick={e => e.stopPropagation()}
      required
    />
  ) : (
    <input
      type={subType === CellSubType.LONG || subType === CellSubType.DOUBLE ? "number" : "text"}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKey}
      onClick={e => e.stopPropagation()}
      onBlur={() => onCommit(value)}
      style={hideInputStyles ? { width: `${value.length || 1}ch` } : {}}
      className={
        hideInputStyles
          ? "outline-none border-none bg-transparent p-0 mr-3"
          : "p-inputtext p-component w-full"
      }
    />
  );
};

export default EditableCell;
